import type { Role } from '@form-factory/schema/enums';
import { memo, type ReactNode } from 'react';

import { useUser } from '@/hooks';

export type ProtectedProps = {
  roles: Role[];
  children: ReactNode;
};

/**
 * Component that checks if the user is authorized to access the route.
 * If the user is not authorized, it returns null.
 * If the user is authorized, it returns the children.
 */
export const Protected = memo(function Protected({
  roles,
  children,
}: ProtectedProps) {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  if (!roles.includes(user.role)) {
    return null;
  }

  return children;
});
